// Video Popup functionality
document.addEventListener('turbo:load', function() {
  // Find all play buttons
  const playButtons = document.querySelectorAll('.video-play-button');

  // Create modal elements once
  const modalOverlay = document.createElement('div');
  modalOverlay.className = 'fixed inset-0 bg-black bg-opacity-75 z-50 flex items-center justify-center hidden transition-opacity duration-300 opacity-0';
  modalOverlay.id = 'video-modal-overlay';

  const modalContent = document.createElement('div');
  modalContent.className = 'relative bg-white rounded-lg shadow-xl max-w-4xl w-full mx-4 md:mx-auto transition-transform duration-300 transform scale-95';

  const closeButton = document.createElement('button');
  closeButton.className = 'absolute top-4 right-4 text-gray-500 hover:text-gray-700 z-10';
  closeButton.innerHTML = `
    <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
    </svg>
  `;

  const videoContainer = document.createElement('div');
  videoContainer.className = 'aspect-video w-full';

  const videoElement = document.createElement('iframe');
  videoElement.className = 'w-full h-full';
  videoElement.setAttribute('frameborder', '0');
  videoElement.setAttribute('allowfullscreen', 'true');

  // Assemble the modal
  videoContainer.appendChild(videoElement);
  modalContent.appendChild(closeButton);
  modalContent.appendChild(videoContainer);
  modalOverlay.appendChild(modalContent);

  // Add to body
  document.body.appendChild(modalOverlay);

  // Function to open the modal
  function openVideoModal(videoUrl) {
    // Set the video source
    videoElement.setAttribute('src', videoUrl);

    // Show the modal
    modalOverlay.classList.remove('hidden');

    // Use setTimeout to ensure the transition works properly
    setTimeout(() => {
      modalOverlay.classList.add('opacity-100');
      modalContent.classList.add('scale-100');
      modalContent.classList.remove('scale-95');
    }, 10);

    // Prevent body scrolling
    document.body.classList.add('overflow-hidden');
  }

  // Function to close the modal
  function closeVideoModal() {
    // Hide the modal with transition
    modalOverlay.classList.remove('opacity-100');
    modalContent.classList.remove('scale-100');
    modalContent.classList.add('scale-95');

    // After transition completes, hide completely and reset video
    setTimeout(() => {
      modalOverlay.classList.add('hidden');
      videoElement.setAttribute('src', '');
      document.body.classList.remove('overflow-hidden');
    }, 300);
  }

  // Add click event listeners to play buttons
  playButtons.forEach(button => {
    button.addEventListener('click', function(e) {
      e.preventDefault();

      // Get the video URL from data attribute
      const videoUrl = this.getAttribute('data-video-url')

      openVideoModal(videoUrl);
    });
  });

  // Close modal when clicking the close button
  closeButton.addEventListener('click', closeVideoModal);

  // Close modal when clicking outside the content
  modalOverlay.addEventListener('click', function(e) {
    if (e.target === modalOverlay) {
      closeVideoModal();
    }
  });

  // Close modal on ESC key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && !modalOverlay.classList.contains('hidden')) {
      closeVideoModal();
    }
  });
});
